import { LlmArtifactViewerComponent, LlmComponent } from '@adaptiva/ai/widgets';
import { AdaBindMethodPipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { AppShellComponentModule } from '@adaptiva/widgets/app-shell';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { DrawerComponent } from '@adaptiva/widgets/drawer';
import { DynamicScreenComponentModule } from '@adaptiva/widgets/dynamic-screen';
import { IconComponent } from '@adaptiva/widgets/icon';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { SplitterComponent } from '@adaptiva/widgets/splitter';
import { StatefulDirective } from '@adaptiva/widgets/stateful';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminPortalAppShellComponent } from './admin-portal-app-shell.component';
import { AdminPortalBodyComponent } from './admin-portal-body/admin-portal-body.component';
import { AdminPortalHeaderComponent } from './admin-portal-header/admin-portal-header.component';

const WIDGETS: Type<any>[] = [
	AppShellComponentModule,
	ButtonComponentModule,
	ComboComponentModule,
	DrawerComponent,
	DynamicScreenComponentModule,
	InputComponentModule,
	LlmArtifactViewerComponent,
	LlmComponent,
	MenuComponentModule,
	OverlayComponentModule,
	SplitterComponent,
	IconComponent,
	SignpostComponentModule,
	TextComponentModule,
];

@NgModule({
	imports: [
		AdaBindMethodPipe,
		CommonModule,
		RouterModule,
		StatefulDirective,
		TemplateMarkerDirectiveModule,
		WIDGETS
	],
	declarations: [
		AdminPortalAppShellComponent,
		AdminPortalHeaderComponent,
		AdminPortalBodyComponent
	],
	exports: [
		AdminPortalAppShellComponent
	],
})
export class AdminPortalAppShellComponentModule {

}
